module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3uwwt"))).then(() => parcelRequire('f4eak'));